import React from 'react';
import { formatCurrency } from '../../Utils/Formatters';
import { TbCircleFilled, TbInfoCircle } from 'react-icons/tb';
import Button from '../Form/Button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface FidelityRegulationProps {
    company: any;
}

const FidelityRegulation = ({ company }: FidelityRegulationProps) => {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const currencyName = company.fidelity.currency_name || "Pontos";

    if (!company?.fidelity) return null;

    return (
        <div id="fidelity-regulation" className="w-full  flex flex-col gap-4">

            <div className="flex items-center gap-1 font-bold">
                <TbInfoCircle />
                <span>{t('layout.fidelity.regulation.title')}</span>
            </div>

            <div className="w-full max-w-2xl px-4">
                <ul className="list-none text-sm space-y-2">
                    <li className="flex items-center gap-2 leading-none">
                        <TbCircleFilled size={8} className='text-custom-primary' />
                        <span dangerouslySetInnerHTML={{ __html: t('layout.fidelity.regulation.item_1', { value: formatCurrency(company.fidelity.minimum_order_value) })}} />
                    </li>
                    <li className="flex items-center gap-2 leading-none">
                        <TbCircleFilled size={8} className='text-custom-primary' />
                        <span dangerouslySetInnerHTML={{ __html: t('layout.fidelity.regulation.item_2', { value: formatCurrency(company.fidelity.value_by_point), currencyName: currencyName, points: company.fidelity.points_by_value }) }} />
                    </li>
                    <li className="flex items-center gap-2 leading-none">
                        <TbCircleFilled size={8} className='text-custom-primary' />
                        <span dangerouslySetInnerHTML={{ __html: t('layout.fidelity.regulation.item_3', { currencyName: currencyName, value: formatCurrency(company.fidelity.point_value) }) }} />
                    </li>
                    <li className="flex items-center gap-2 leading-none">
                        <TbCircleFilled size={8} className='text-custom-primary' />
                        <span dangerouslySetInnerHTML={{ __html: t('layout.fidelity.regulation.item_4', { days_to_expire: company?.fidelity?.days_to_expire }) }} />
                    </li>
                </ul>

                {company.fidelity.regulation && (
                    <div className="mt-8 pt-8 border-t border-gray-100 prose prose-lg max-w-none text-gray-600" dangerouslySetInnerHTML={{ __html: company.fidelity.regulation }} />
                )}
            </div>

            <div className="flex flex-col items-center text-center gap-4 text-sm my-6 w-full">
                <p className='text-gray-400 italic leading-none'>{t('layout.fidelity.regulation.attention')}</p>
                <Button onClick={() => navigate('/programa-de-fidelidade/termos-de-uso')} className=" w-fit">
                    {t('layout.fidelity.regulation.button_label')}
                </Button>
            </div>
        </div>
    );
};

export default FidelityRegulation;
